import { Component } from '@angular/core';
import { AppComponentBase } from 'src/app/core/utils/base-components/app-component-base';

@Component({
  selector: 'app-root',
  templateUrl: './page-not-found.component.html',
  standalone: false
})
export class PageNotFoundComponent extends AppComponentBase {
  constructor() {
    super();
  }
}

